export default __webpack_public_path__ + "static/clusterbuild4-5dc372dd817cf4813296d150a9c23fcc.png";